<template>
  <v-row align="center">

    <!-- <v-col md="1">
      <span style="font-size: 18px; font-weight: 400;">Helpers: </span>
    </v-col> -->

    <v-col cols="auto" class="ml-auto mr-4">
      <v-btn color="" @click="">
        Cancel
      </v-btn>
      &nbsp;
      <v-btn color="primary" @click="">
        Save
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'AdsHelpers'
  }
</script>
